module.exports = __webpack_public_path__ + "assets/img/line7.e6d3b4bb.png";